import axios from "axios";  
import { loadConfig, getToken } from "../utility";

let config = await loadConfig();

export default function ServiceController() {
	const token = getToken();

	//> getResidences
	this.getResidences = async function () {
		let result = {
			isSuccess: true,
			message: "Success",
			value: [
				{
					residenceId: "",
					name: "",
					cityName: "",
					fileId: "",
					imageUrl: "",
					totalCapacity: 0,
					totalRoomTypes: 0,
				},
			],
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}Service/GetResidences`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};

	//> getResidence
	this.getResidence = async function (residenceId) {
		let result = {
			isSuccess: true,
			message: "Success",
			value: {
				name: "",
				cityName: "",
				imageUrl: "",
				laws: "",
				roomTypes: [
					{
						residenceRoomTypeId: "",
						roomTypeName: "",
						roomPrice: 0,
						extraPersonPrice: 0,
						imageUrl: "",
					},
				],
			},
		};
		try {
			const response = await axios.request({
				method: "get",
				maxBodyLength: Infinity,
				url: `${config.apiBaseUrl}Service/getResidence/?residenceId=${residenceId}`,
				headers: {
					accept: "application/json",
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				data: null,
			});
			result.value = response.data;
		} catch (error) {
			result.isSuccess = false;
			result.message = error.toString();
			if (error.response && error.response.status === 400)
				result.message = error.response.data;
		}
		return result;
	};
}
